import { API_ENVIAR_EMAIL } from '@/config';
import * as AwsSigningUtils from '@/library/utils/aws-signing';

export async function compartirBoletaEmail(to, rut, razonSocial, monto, folio, dte, url, fecha){

	let urlApi = API_ENVIAR_EMAIL;

	const body = { monto, folio, dte, rutDV: rut, razonSocial, to, fecha, url}

	return new Promise((resolve, reject) => AwsSigningUtils.executeJSONSignedRequest('POST', urlApi, body, resolve, reject));
}